export const IconClasses = {
  XS : 'w-4 h-4',
  SM : 'w-5 h-5',
  MD : 'w-6 h-6',
  LG : 'w-8 h-8',
  XL : 'w-10 h-10',
  XXL: 'w-12 h-12',
} as const;